/* AddRangeRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;
const InputSelectControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .ComboBox;
const RadioControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .InputRadio;

const _ = require("lodash");

const ipv4SubnetOptions = Array.from(Array(11)).map((e, i) => {
    return {
        label: i + 22,
        value: i + 22,
    };
});

const ipv6SubnetOptions = Array.from(Array(11)).map((e, i) => {
    return {
        label: i + 118,
        value: i + 118,
    };
});

const ipv4Default = 24;
const ipv6Default = 120;

class AddEditRangeRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("add-range-veil");
        this._rootElem.component = this._model;

        this._ipBlockV4Val = undefined;
        this._ipBlockV6Val = undefined;

        this._ipVersionInputBlock = new RadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "IPv4",
                    tooltip: "Select to use IPv4 format",
                    value: false,
                },
                {
                    label: "IPv6",
                    tooltip: "Select to use IPv6 format",
                    value: true,
                },
            ],
            value: false,
        });

        // this._ipVersionInputRange = new RadioControl({
        //     darkTheme: true,
        //     horizontal: true,
        //     options: [
        //         {
        //             label: "IPv4",
        //             tooltip: "Select to use IPv4 format",
        //             value: false,
        //         },
        //         {
        //             label: "IPv6",
        //             tooltip: "Select to use IPv6 format",
        //             value: true,
        //         },
        //     ],
        //     value: false,
        // });

        this._typeField = new InputSelectControl({
            darkTheme: true,
            placeholder: "IP Range",
            options: [
                {label: "IP Range", value: "ipRange"},
                {label: "IP Block", value: "ipBlock"},
            ],
            value: this._model._type || "ipRange",
        });

        this._ipRangeSection = document.createElement("div");
        this._ipRangeSection.classList.add("ip-range");
        this._startField = new InputTextControl({
            darkTheme: true,
            placeholder: "Start IP Address",
        });

        this._endField = new InputTextControl({
            darkTheme: true,
            placeholder: "End IP Address",
        });

        this._ipBlockSection = document.createElement("div");
        this._ipBlockSection.classList.add("ip-block");

        this._ipField = new InputTextControl({
            darkTheme: true,
            placeholder: "IP Address",
        });

        this._subnetField = new InputSelectControl({
            darkTheme: true,
            placeholder: "Subnet",
            label: "Subnet",
            options: ipv4SubnetOptions,
            value: ipv4Default,
        });

        this._confirmButton = new ButtonControl({
            label: "OK",
            darkTheme: true,
            theme: "additive",
            disabled: true,
            active: true,
        });
        this._cancelButton = new ButtonControl({
            label: "Cancel",
        });
        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model._title;

        this._messageBox = document.createElement("p");
        this._messageBox.innerText = this.model.message;

        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._confirmButton.on(
            "UserClick",
            (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this))
        );
        this._cancelButton.on(
            "UserClick",
            (this._onCancelButtonClick = this._onCancelButtonClick.bind(this))
        );

        this._typeField.on("UserValue", (this.checkTypeValue = this.checkTypeValue.bind(this)));
        this._startField.on("UserValue", (this.checkStartValue = this.checkStartValue.bind(this)));
        this._endField.on("UserValue", (this.checkEndValue = this.checkEndValue.bind(this)));
        this._ipField.on("UserValue", (this.checkIPValue = this.checkIPValue.bind(this)));
        this._subnetField.on(
            "UserValue",
            (this.checkSubnetValue = this.checkSubnetValue.bind(this))
        );
        this._ipVersionInputBlock.on(
            "UserValue",
            (this._ipVerBlockChange = this._ipVerBlockChange.bind(this))
        );
        // this._ipVersionInputRange.on(
        //     "UserValue",
        //     (this._ipVerRangeChange = this._ipVerRangeChange.bind(this))
        // );
    }
    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
        this._typeField.removeAllListeners("UserValue");
        this._startField.removeAllListeners("UserValue");
        this._endField.removeAllListeners("UserValue");
        this._ipField.removeAllListeners("UserValue");
        this._subnetField.removeAllListeners("UserValue");
        this._ipVersionInputBlock.removeAllListeners("UserValue");
        // this._ipVersionInputRange.removeAllListeners("UserValue");
    }

    checkTypeValue() {
        this._showHideSections();
        this.checkValue();
    }

    checkStartValue() {
        this.checkValue();
    }

    checkEndValue() {
        this.checkValue();
    }
    checkIPValue() {
        this.checkValue();
    }

    checkSubnetValue() {
        this.checkValue();
    }

    _ipVerBlockChange(val) {
        if (val) {
            this._ipBlockV4Val = this._subnetField.getValue();
            this._subnetField.setOptions(ipv6SubnetOptions);
            this._subnetField.setValue(this._ipBlockV6Val || ipv6Default);
        } else {
            this._ipBlockV6Val = this._subnetField.getValue();
            this._subnetField.setOptions(ipv4SubnetOptions);
            this._subnetField.setValue(this._ipBlockV4Val || ipv4Default);
        }
        this.checkValue();
    }

    _ipVerRangeChange() {
        this.checkValue();
    }

    _onConfirmButtonClick() {
        this._callCreateAction();
    }
    _onCancelButtonClick() {
        this._model.cancelAction();
    }
    _checkForImpliedConfirm(event) {
        if (event.keyCode === 13) {
            if (!_.isEmpty(this._nameField.getValue())) {
                this._callCreateAction();
            }
        }
    }
    checkValue() {
        if (this._typeField.getValue() === "ipRange") {
            // const ipType = this._ipVersionInputRange.getValue();
            this._confirmButton.disabled =
                _.isEmpty(this._startField.getValue()) ||
                this._startField.getValue().trim().length === 0 ||
                !this._validateIp(this._startField.getValue(), false).valid ||
                _.isEmpty(this._endField.getValue()) ||
                this._endField.getValue().trim().length === 0 ||
                !this._validateIp(this._endField.getValue(), false).valid;
        } else {
            const ipType = this._ipVersionInputBlock.getValue();
            this._confirmButton.disabled =
                _.isEmpty(this._ipField.getValue()) ||
                this._ipField.getValue().trim().length === 0 ||
                !this._validateIp(this._ipField.getValue(), ipType).valid;
        }
    }

    _validateIp(val, type) {
        let ipType = 4;
        const v6expression = /^([0-9A-Fa-f]{1,4}::?){1,7}[0-9A-Fa-f]{1,4}$/;
        const v4expression =
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        if (_.isUndefined(type)) {
            if (v4expression.test(val)) {
                ipType = 4;
                return {
                    ipType,
                    valid: true,
                };
            }
            if (v6expression.test(val)) {
                ipType = 6;
                return {
                    ipType,
                    valid: true,
                };
            }
            return {
                ipType,
                valid: false,
            };
        }

        if (type) {
            ipType = 6;
        } else {
            ipType = 4;
        }

        if (ipType === 4) {
            if (v4expression.test(val)) {
                return {
                    ipType,
                    valid: true,
                };
            }
        }
        if (ipType === 6) {
            if (v6expression.test(val)) {
                return {
                    ipType,
                    valid: true,
                };
            }
        }

        return {
            ipType,
            valid: false,
        };
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [
            this._typeField.shutdown(),
            this._startField.shutdown(),
            this._endField.shutdown(),
            this._confirmButton.shutdown(),
            this._cancelButton.shutdown(),
            this._ipVersionInputBlock.shutdown(),
            // this._ipVersionInputRange.shutdown(),
        ];

        return Promise.all(promArr).then(
            () => {
                this._typeField = undefined;
                this._startField = undefined;
                this._endField = undefined;
                this._confirmButton = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._messageBox.remove();
                this._messageBox = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._cancelButton = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "BaseCreateRenderer.shutdown() error");
            }
        );
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);

                this._rootElem.appendChild(
                    this._createSection("Type", this._typeField, "type-container")
                );

                // this._ipRangeSection.appendChild(
                //     this._createSection("IP Version", this._ipVersionInputRange)
                // );
                this._ipRangeSection.appendChild(
                    this._createSection("Start IP Address", this._startField)
                );
                this._ipRangeSection.appendChild(
                    this._createSection("End IP Address", this._endField)
                );

                this._ipBlockSection.appendChild(
                    this._createSection("IP Version", this._ipVersionInputBlock)
                );
                this._ipBlockSection.appendChild(this._createSection("IP Address", this._ipField));
                this._ipBlockSection.appendChild(this._createSection("Subnet", this._subnetField));

                this._rootElem.appendChild(this._ipRangeSection);
                this._rootElem.appendChild(this._ipBlockSection);

                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);
                this._rootElem.appendChild(this._buttonContainer);

                if (!_.isEmpty(this._model._context)) {
                    if (this._model._type === "ipRange") {
                        this._startField.setValue(this._model._start);
                        this._endField.setValue(this._model._end);
                        // const validStartIp = this._validateIp(this._model._start);
                        // if (validStartIp.ipType === 6) {
                        //     this._ipVersionInputRange.setValue(true);
                        // } else {
                        //     this._ipVersionInputRange.setValue(false);
                        // }
                    } else if (this._model._type === "ipBlock") {
                        this._ipField.setValue(this._model._ipAdd);
                        const validIp = this._validateIp(this._model._ipAdd);
                        if (validIp.ipType === 6) {
                            this._ipVersionInputBlock.setValue(true);
                            this._subnetField.setOptions(ipv6SubnetOptions);
                            this._ipBlockV6Val = this._model._subnet;
                        } else {
                            this._ipVersionInputBlock.setValue(false);
                            this._subnetField.setOptions(ipv4SubnetOptions);
                            this._ipBlockV4Val = this._model._subnet;
                        }
                        this._subnetField.setValue(this._model._subnet);
                    }
                }

                this._showHideSections();
            }
            return resolve();
        });
    }

    _showHideSections() {
        const selectedSection = this._typeField.getValue();

        switch (selectedSection) {
            case "ipBlock":
                this._ipRangeSection.classList.add("hide");
                this._ipBlockSection.classList.remove("hide");
                break;
            default:
                this._ipRangeSection.classList.remove("hide");
                this._ipBlockSection.classList.add("hide");
                break;
        }
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/
    //TODO Private Render Methods here

    _createSection(name, Compnent, className) {
        const section = document.createElement("section");
        const label = document.createElement("label");
        section.className = "key-section";
        if (className) {
            section.classList.add(className);
        }
        label.innerText = name;
        Compnent.setAttribute("rows", "6");
        section.appendChild(label);
        section.appendChild(Compnent.renderer.rootElement);
        return section;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/
    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/
    _callCreateAction() {
        const type = this._typeField.getValue();
        switch (type) {
            case "ipBlock":
                this._model.createAction({
                    type: this._typeField.getValue(),
                    ipBlock: `${this._ipField.getValue()}/${this._subnetField.getValue()}`,
                });
                break;
            default:
                this._model.createAction({
                    type: this._typeField.getValue(),
                    start: this._startField.getValue(),
                    end: this._endField.getValue(),
                });
                break;
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}
module.exports = AddEditRangeRenderer;
